import { PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery'

export const useFetchPaymentReceiverCommandsNoSuspense =
  PaymentReceiversCommandVersionsService_paymentReceiverCommandVersionsServiceGetQuery.useQuery
